export default __webpack_public_path__ + "static/media/saint-malo10.76aa7f6b.jpg";